import router from './index'
import store from '@/store'
import Cookies from "js-cookie";

//定义白名单，即不需要登录也能去的
const whiteList = ['/login']
router.beforeEach((to, from, next) => {
    document.title = to.meta.title + ' - 再漫画' || '再漫画';
    // 判断是否取到token
    // store.getters.token  记得注释token
    if (to.name === 'login' && Cookies.get('token') === undefined) {
        const token = to.query.token;
        if (to.query.token !== undefined) {
            Cookies.set('token', token);
            Cookies.set('token', token, {
                path: '/',
                domain: '.zaimanhua.com',
                expires: new Date(Date.now() + 24 * 60 * 60 * 1000)
            });
        }
    }
    if (Cookies.get('token')) {
        //如果要去页面是login
        if (to.path === '/login') {
            //让他去首页，因为当前在登录页
            next('/')
        } else { //如果不是首页，则让他去
            next()
        }
    } else { //判断是否要去的路径在白名单中，如果在则不管他，如果不在则去登录页
        if (whiteList.includes(to.path)) {
            next()
        } else {
            next('/login')
        }
    }
})
router.afterEach(() => {
    window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动
    });
});